var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.5H1C0.45 3.5 0 3.05 0 2.5V1.5C0 0.95 0.45 0.5 1 0.5H15C15.55 0.5 16 0.95 16 1.5V2.5C16 3.05 15.55 3.5 15 3.5ZM7.5 9.5H0.5C0.225 9.5 0 9.05 0 8.5V7.5C0 6.95 0.225 6.5 0.5 6.5H7.5C7.775 6.5 8 6.95 8 7.5V8.5C8 9.05 7.775 9.5 7.5 9.5ZM0.75 15.5H11.25C11.6625 15.5 12 15.05 12 14.5V13.5C12 12.95 11.6625 12.5 11.25 12.5H0.75C0.3375 12.5 0 12.95 0 13.5V14.5C0 15.05 0.3375 15.5 0.75 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.ebbb1e8e0665685b55233ba49338c5c7.svg";
export { ForwardRef as ReactComponent };